import { EntityDetails } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledEntityDetails = styled(EntityDetails)`
  margin: 0;
`;

export const Name = styled.p`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
